import * as React from "react";
/**
 * See HTMLTooltip.component.tsx for more information
 */
export function HTMLTooltipWrapper({ children, tooltip, tooltipDisabled, tooltipPosition }) {
    return (React.createElement("div", { style: { display: "contents" }, "data-tooltip": tooltip, "data-tooltip-disabled": tooltipDisabled, "data-tooltip-position": tooltipPosition, "data-tooltip-wrapper": true }, children));
}
